(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("weatherKarcherActions", weatherKarcherActionsFactory);

  /** @ngInject */
  function weatherKarcherActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $log
  ) {
    return {
      getCurrentWeather: getCurrentWeather,
      getHistoryWeather: getHistoryWeather
    };

    function getCurrentWeather(latitude, longitude) {
      var deferred = $q.defer();
      api.getCurrentWeather(latitude, longitude).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    }

    function getHistoryWeather(latitude, longitude, from, to) {
      var deferred = $q.defer();
      api.getHistoryWeather(latitude, longitude, from, to).then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            $log.error(errorData);
          }
      );

      return deferred.promise;
    }

  }
})();
